import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppInitializer } from '@/components/AppInitializer';

import '@/i18n';
import '@/index.css';
import '@knack/asterisk-react/style.css';

import { AppProviders } from '@/AppProviders';
import { Router } from '@/Router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 1000 * 60 * 10 // Set the default stale time to 10 minutes
    }
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppInitializer>
        <AppProviders>
          <Router />
        </AppProviders>
      </AppInitializer>
    </QueryClientProvider>
  </React.StrictMode>
);
